export default {
  state: {
    // 用户跟进人信息
    followInfoCache: {},
  },
  mutations: {
    // 设置跟进人信息
    setFollowInfoCache(state, { key, data }) {
      if (!state.followInfoCache) {
        state.followInfoCache = {}
      }
      state.followInfoCache[key] = data
    },
  },
}
